/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {map, Observable} from 'rxjs';
import {
  SensorsFormInterface,
  SensorsListInterface,
  SensorSummaryInterface,
} from 'src/app/shared/interface/settings/system/sesnors';
import {inject, Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';
import {HTTP_CODE_SUCCESS} from '@shared/constants';
import {CoreValidateFormulaInterface} from '@shared/interface/common/valid-formula.interface';
import {MkadCoreService} from '@shared/services/settings/mkad-core.service';

@Injectable({
  providedIn: 'root',
})
export class MkadSensorsService extends MkadBaseService {
  readonly sensors = URLS_SERVICE.system.sensors;
  readonly formula = URLS_SERVICE.core.validateFormula;
  private readonly coreService = inject(MkadCoreService);

  list(): Observable<SensorsListInterface[]> {
    return this.http.post<SensorsListInterface[]>(this.baseCore + this.sensors.base + this.sensors.list);
  }

  summary(): Observable<SensorSummaryInterface[]> {
    return this.http.post<SensorSummaryInterface[]>(this.baseCore + this.sensors.base + this.sensors.summary);
  }

  validateFormula(params: CoreValidateFormulaInterface): Observable<boolean> {
    return this.coreService.validateSensorFormula(params);
  }

  create(payload: SensorsFormInterface): Observable<SensorsFormInterface> {
    return this.http.post<SensorsFormInterface>(this.baseCore + this.sensors.base + this.sensors.create, payload);
  }

  update(payload: SensorsFormInterface): Observable<SensorsFormInterface> {
    return this.http.post<SensorsFormInterface>(this.baseCore + this.sensors.base + this.sensors.update, payload);
  }

  get(param: number): Observable<SensorsListInterface> {
    return this.http.post<SensorsListInterface>(this.baseCore + this.sensors.base + this.sensors.get, {id: param});
  }

  /**
   * @description
   * Method that delete a specific sensor
   * @param param id of the customer
   */
  delete(param: number): Observable<boolean> {
    return this.http.post<HttpResponse<boolean>>(this.baseCore + this.sensors.base + this.sensors.delete, {id: param}).pipe(
      map((prevResponse) => {
          if (!prevResponse) return true;
          return prevResponse.status === HTTP_CODE_SUCCESS;
        },
      ));
  }
}
